/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TenantDetails } from 'app/page-modules/tenant-management/models';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'og-tenant-setup',
  templateUrl: './tenant-setup.component.html',
  styleUrls: ['./tenant-setup.component.scss'],
  standalone: false
})
export class TenantSetupComponent {
  /** The tenant details form to use */
  @Input() tenantDetailsFormGroup: FormGroup;
  /** Emits tenant name changes */
  @Output() nameChange = new EventEmitter<string>();
  /** Emits tenant organization id changes */
  @Output() organizationIdChange = new EventEmitter<string>();
  /** Emits tenant details changes on form submission */
  @Output() tenantDetailsChange = new EventEmitter<TenantDetails>();
  /** Emits form submission events */
  @Output() formSubmission = new EventEmitter<void>();
  /** Emits cancel clicks  */
  @Output() cancelClick = new EventEmitter<void>();

  permissions: string[] = [];
  emailDomains: string[] = [];

  onNameChange(event: KeyboardEvent): void {
    this.nameChange.next((<HTMLTextAreaElement>event.target).value);
  }

  onOrganizationIdChange(event: KeyboardEvent): void {
    this.organizationIdChange.next((<HTMLTextAreaElement>event.target).value);
  }

  onSubmitClick(): void {
    const emailDomainsWithConnectionTypes = this.emailDomains.reduce((acc, curr) => {
      const [domain] = curr.split(':');
      acc[domain] = '';
      return acc;
    }, {} as { [key: string]: string });

    this.tenantDetailsChange.next({
      name: this.tenantDetailsFormGroup.get('name')!.value,
      organizationId: this.tenantDetailsFormGroup.get('organizationId')!.value,
      permissions: this.permissions,
      emailDomainsWithConnectionTypes,
      history: {},
      status: 'provisioning',
      tags: []
    });
    this.formSubmission.next();
  }

  onCancelClicked(): void {
    this.cancelClick.next();
  }
}
